import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref } from "vue"

const _hoisted_1 = { class: "mobile-confirm-section" }
const _hoisted_2 = { class: "mobile-confirm-header" }
const _hoisted_3 = { class: "mobile-confirm-title" }
const _hoisted_4 = { class: "mobile-confirm-content" }
const _hoisted_5 = { class: "selected-lines-header" }
const _hoisted_6 = { class: "selected-lines-label" }
const _hoisted_7 = { class: "mobile-lines-list" }
const _hoisted_8 = { class: "mobile-line-content" }
const _hoisted_9 = { class: "mobile-line-balls" }
const _hoisted_10 = {
  key: 0,
  class: "mobile-line-color-bonus"
}
const _hoisted_11 = { class: "mobile-line-color-bonus-text" }
const _hoisted_12 = {
  key: 1,
  class: "mobile-line-bonus"
}
const _hoisted_13 = { class: "mobile-line-bonus-ball" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "mobile-footer" }
const _hoisted_16 = ["disabled"]


import { getColorComboLineBonusLabel } from '@/constants/standardBetPlusColorBonus';
import type { BallColorSlug } from '@/constants/sameColorBalls';

interface Line {
  numbers: number[];
  bonus?: number;
  bonusColor?: BallColorSlug;
  numBets: number;
  picks: number;
  market?: {
    label?: string;
    odds?: number;
    market?: {
      slug?: string;
    };
  };
}

interface Props {
  lines: Line[];
  currentGameSlug?: string;
  selectedRelatedGames?: string[];
  isProcessing?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileConfirmSection',
  props: {
    lines: { default: () => [] },
    currentGameSlug: { default: '' },
    selectedRelatedGames: { default: () => [] },
    isProcessing: { type: Boolean, default: false }
  },
  emits: [
  'clear-all',
  'remove-line',
  'add-to-betslip',
  'update:selectedRelatedGames',
],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('detail.confirmEntries')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('detail.selectedLines', { count: _ctx.lines.length })), 1),
        (_ctx.lines.length > 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "mobile-clear-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clear-all')))
            }, _toDisplayString(_ctx.$t('common.clearAll')), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lines, (line, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "mobile-line-item"
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(line.numbers, (num) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: 'main-' + num,
                    class: "mobile-line-ball"
                  }, _toDisplayString(num), 1))
                }), 128)),
                (_unref(getColorComboLineBonusLabel)(line))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "mobile-line-bonus-separator" }, "+", -1)),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(getColorComboLineBonusLabel)(line)), 1)
                    ]))
                  : (line.bonus)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "mobile-line-bonus-separator" }, "+", -1)),
                        _createElementVNode("span", _hoisted_13, _toDisplayString(line.bonus), 1)
                      ]))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                class: "mobile-remove-line-btn",
                onClick: ($event: any) => (_ctx.$emit('remove-line', index))
              }, " × ", 8, _hoisted_14)
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("button", {
          class: "mobile-add-to-betslip-btn",
          disabled: _ctx.lines.length === 0 || _ctx.isProcessing,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('add-to-betslip', _ctx.lines)))
        }, _toDisplayString(_ctx.$t('detail.addToBetslip')), 9, _hoisted_16)
      ])
    ])
  ]))
}
}

})